<h3 mat-dialog-title>Brug af cookies</h3>

<div mat-dialog-content>
  Vi bruger cookies på {{ windowService.getHostname() }}. Ved at fortsætte accepter du dette. Du kan finde yderligere information om vores
  <a routerLink="/privacy-policy" routerLinkActive="active">privatlivpolitik</a> og
  <a routerLink="/terms-of-use" routerLinkActive="active">betingelser for brug</a>.
</div>

<div mat-dialog-actions>
  <button mat-raised-button type="submit" color="primary" (click)="ok()">OK</button>
</div>
